import { Tag } from "lucide-react";
import { promotions } from "../data/servicio";

export default function Promotions() {
  const featured = promotions.find(p => p.id === "pack-10-kine") || promotions[0];
  const others = promotions.filter(p => p.id !== featured.id);

  return (
    <section id="Promociones" className="py-20 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-[#E6F5FF]/70 to-white pointer-events-none"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">

       {/* Título */}
        <div className="max-w-2xl mb-16">
          <div className="mb-6">
            <h2 className="text-3xl md:text-4xl font-semibold text-[#0F1B2D] mb-3">
              Promos y descuentos
            </h2>
            <div className="w-36 h-1.5 bg-[#2E8BC0] rounded-full"></div>
          </div>

          <p className="text-[#5E738A] text-lg mt-5">
            Elegí el plan que mejor se adapte a tu tratamiento.
          </p>
        </div>


        {/* GRID */}
        <div className="grid gap-10 lg:grid-cols-[2fr,1.2fr]">

          {/* DESTACADA */}
          <div className="
            bg-white rounded-3xl shadow-xl border border-[#2E8BC0]/20 p-10 relative overflow-hidden
            transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 hover:border-[#2E8BC0]
            animate-slide-up
          ">
            
            {/* Figuras decorativas */}
            <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#2E8BC0]/10 blur-xl"></div>
            <div className="absolute -left-8 bottom-0 h-28 w-28 rounded-full bg-[#2E8BC0]/10 blur-lg"></div>

            {/* Encabezado */}
            <div className="flex items-center gap-3 mb-6">
              <div className="h-12 w-12 rounded-xl bg-[#E6F5FF] flex items-center justify-center text-[#2E8BC0] shadow-sm">
                <Tag className="h-6 w-6" />
              </div>
              <span className="px-4 py-1 rounded-full text-xs font-bold bg-[#2E8BC0] text-white tracking-wide shadow">
                MÁS ELEGIDO
              </span>
            </div>

            {/* Título */}
            <h3 className="text-3xl font-semibold text-[#0F1B2D] mb-4 leading-tight">
              {featured.title}
            </h3>

            <p className="text-[#5E738A] text-lg leading-relaxed mb-6 max-w-xl">
              {featured.description}
            </p>

            <ul className="space-y-2 text-[#0F1B2D] text-base mb-8">
              <li>• Mayor continuidad en el tratamiento.</li>
              <li>• Seguimiento profesional sesión a sesión.</li>
              <li>• Valor preferencial por cantidad de sesiones.</li>
            </ul>

            {/* BOTÓN */}
            <a
              href="https://wa.me/5491156601095?text=Hola!%20Quiero%20consultar%20sobre%20esta%20promo"
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-flex items-center justify-center gap-2 px-7 py-3 rounded-xl
                bg-[#2E8BC0] hover:bg-[#0F1B2D] text-white text-base font-semibold
                transition-all duration-200 shadow-md hover:shadow-lg active:scale-95
              "
            >
              Consultar por esta promo →
            </a>

            <p className="text-xs text-[#5E738A] mt-4">
              * Promos sujetas a disponibilidad y evaluación profesional.
            </p>
          </div>

          {/* OTRAS PROMOS */}
          <div className="space-y-6">
            {others.map((promo, i) => (
              <div
                key={promo.id}
                className="
                  bg-white rounded-2xl shadow-md border border-white/70 p-6
                  transition-all duration-200 hover:-translate-y-1 hover:shadow-xl hover:border-[#2E8BC0]
                  hover:ring-2 hover:ring-[#2E8BC0]/20 cursor-pointer animate-fade-in
                "
                style={{ animationDelay: `${0.15 * i}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className="h-10 w-10 rounded-xl bg-[#E6F5FF] flex items-center justify-center text-[#2E8BC0] shadow-sm">
                    <Tag className="h-4 w-4" />
                  </div>

                  <div>
                    <h4 className="text-[#0F1B2D] font-semibold text-lg mb-1">
                      {promo.title}
                    </h4>
                    <p className="text-[#5E738A] text-sm leading-relaxed">
                      {promo.description}
                    </p>
                  </div>
                </div>

                {/* Botón chico */}
                <a
                  href="https://wa.me/5491156601095?text=Hola!%20Quiero%20consultar%20sobre%20esta%20promo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
                    inline-flex items-center gap-1 text-[#2E8BC0] mt-4 font-medium hover:text-[#0F1B2D]
                    transition-colors
                  "
                >
                  Consultar por esta promo →
                </a>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
